import { Component } from "@angular/core";
import { Observable, of } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { Menu } from "src/app/models/menu";
import { StyleColors } from "src/app/models/style-colors";

interface MenuEdit extends Menu {
  subMenu: MenuEdit[];
  editing: boolean;
  editName: string;
  editColor: string;
  editPageName: string;
}

@Component({
  templateUrl: "./exammenuedit.component.html",
  styleUrls: ["./exammenuedit.component.scss"],
})
export class ExamMenuEditComponent {
  menu: MenuEdit[];
  pages: string[];
  styleColors: StyleColors;

  constructor(private examService: ExamService) {
    this.styleColors = {
      title: { bg: "#FF0", color: "#000" },
      technique: { bg: "#F0F", color: "#000" },
      variation: { bg: "#0FF", color: "#000" },
      pac: { bg: "#F00", color: "#000" },
      exam: { bg: "#00F", color: "#000" },
      default: { bg: "transparent", color: "#000" },
    };
    let style = Config.STYLE[this.examService.currentExam.style];
    if (style) {
      this.styleColors = {
        title: style["color-title"],
        technique: style["color-technique"],
        variation: style["color-variation"],
        pac: style["color-pac"],
        exam: style["color-exam"],
        default: style["color-default"],
      };
    }

    this.pages = this.examService.currentExam.pages.map(item => item.name);
    this.menu = this.examService.currentExam.menu.map(item => {
      let ret = this.menu2menuEdit(item);
      if (!this.pages.includes(ret.pageName)) {
        ret.pageName = "";
      }
      return ret;
    });
  }

  private menu2menuEdit(menu: Menu): MenuEdit {
    let subMenu: MenuEdit[];
    if (menu.subMenu) {
      subMenu = menu.subMenu.map(item => this.menu2menuEdit(item));
    } else {
      subMenu = null;
    }
    let menuEdit: MenuEdit = {
      ...menu,
      subMenu,
      editing: false,
      editName: "",
      editColor: "",
      editPageName: "",
    };
    return menuEdit;
  }

  private menuEdit2menu(menuEdit: MenuEdit): Menu {
    let subMenu: Menu[];
    if (menuEdit.subMenu) {
      subMenu = menuEdit.subMenu.map(item => this.menuEdit2menu(item));
    } else {
      subMenu = null;
    }
    let menu: Menu = {
      color: menuEdit.color,
      name: menuEdit.name,
      pageName: menuEdit.pageName,
      subMenu,
      showSubMenu: true,
    };
    return menu;
  }

  private collapseMenu(menu: MenuEdit[], collapse: boolean): void {
    for (let m of menu) {
      m.showSubMenu = !collapse;
      if (m.subMenu) {
        this.collapseMenu(m.subMenu, collapse);
      }
    }
  }

  moveMenuUp(parent: MenuEdit, menu: MenuEdit): void {
    let list = parent === null ? this.menu : parent.subMenu;

    let index = list.indexOf(menu);
    if (index >= 1) {
      let tmp = list[index - 1];
      list[index - 1] = list[index];
      list[index] = tmp;
    }
  }

  moveMenuDown(parent: MenuEdit, menu: MenuEdit): void {
    let list = parent === null ? this.menu : parent.subMenu;

    let index = list.indexOf(menu);
    if (index >= 0 && index < list.length - 1) {
      let tmp = list[index + 1];
      list[index + 1] = list[index];
      list[index] = tmp;
    }
  }

  addSubMenu(menu: MenuEdit): void {
    if (!menu.subMenu) {
      menu.subMenu = [];
    }
    menu.showSubMenu = true;
    menu.subMenu.push({
      color: "",
      name: "New Menu",
      pageName: "",
      subMenu: null,
      editing: false,
      editName: "",
      editColor: "",
      editPageName: "",
    });
  }

  removeMenu(parent: MenuEdit, menu: MenuEdit): void {
    let list = parent === null ? this.menu : parent.subMenu;

    let index = list.indexOf(menu);
    if (index >= 0) {
      list.splice(index, 1);
    }
  }

  editMenu(menu: MenuEdit): void {
    menu.editing = true;
    menu.editName = menu.name;
    menu.editColor = menu.color;
    menu.editPageName = menu.pageName;
  }

  editMenuOk(menu: MenuEdit): void {
    menu.editing = false;
    menu.name = menu.editName;
    menu.color = menu.editColor;
    menu.pageName = menu.editPageName;
  }

  editMenuCancel(menu: MenuEdit): void {
    menu.editing = false;
  }

  colapseAll(): void {
    this.collapseMenu(this.menu, true);
  }

  expandAll(): void {
    this.collapseMenu(this.menu, false);
  }

  newMenu(): void {
    this.menu.push({
      color: "",
      name: "New Menu",
      pageName: "",
      subMenu: null,
      editing: false,
      editName: "",
      editColor: "",
      editPageName: "",
    });
  }

  hasErrors(): boolean {
    return false;
  }

  get value(): any {
    return this.menu.map(item => this.menuEdit2menu(item));
  }

  get onFormStatusChanges(): Observable<boolean> {
    return of(false);
  }
}
